import React from "react";
// import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { ReactComponent as LogoDark } from "../../../assets-v2/images/logos/logo-dark.svg";
import { ReactComponent as LogoLight } from "../../../assets-v2/images/logos/logo-white.svg";

const LogoIcon = () => {
    const INIT_STATE = {
        activeDir: "ltr",
        activeNavbarBg: "#0b70fb",
        activeSidebarBg: "#ffffff",
        activeMode: "light",
        activeTheme: "ORANGE_THEME",
        SidebarWidth: 240
    };
    const customizer = INIT_STATE;
    return (
        <Link underline="none" to="/applications/1">
            {customizer.activeMode === "dark" ? <LogoLight /> : <LogoDark />}
        </Link>
    );
};

export default LogoIcon;
